export const modalConfirmOptions = {
  title: 'Já existem dados submetidos para essa competência',
  showLoaderOnConfirm: true,
  text:
    'Para um novo envio, todos os dados anteriores serão excluídos. Deseja prosseguir?',
  icon: 'warning',
  showCancelButton: true,
  confirmButtonColor: '#74a50a',
  cancelButtonColor: '#d33',
  confirmButtonText: 'Sim, enviar',
  cancelButtonText: 'Cancelar',
};
